<form
  [formGroup]="additionalInfoForm"
  class="d-flex flex-column gap-4 my-4 w-100"
>
  <div>
    <h5 class="fw-bold">{{ 'additionalContact' | i18next }}</h5>
    <div class="containerInputs">
      <div class="emailInput">
        <label for="email">{{ 'additionalEmail' | i18next }}</label>
        <input
          id="email"
          class="primary-input"
          placeholder="emailadicionallargo@dominio.com"
          formControlName="email"
          type="email"
          (change)="emitData()"
        />
      </div>
      <div class="phoneInput">
        <label for="phone">{{ 'additionalPhone' | i18next }}</label>
        <div class="input-wrapper">
          <input
            id="phone"
            class="primary-input"
            placeholder="666666666"
            formControlName="phone"
            type="text"
            (change)="emitData()"
          />
          <mat-icon [matTooltip]="'phoneValidation' | i18next"
            >info_outline</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
</form>
